import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

export const useIRBDocumentsData = (id) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [parsedFormData, setParsedFormData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // Note: Error toast suppression is now handled by URL pattern matching in axios interceptor
        const response = await axiosInstance.get(`/api/requests/progress/by-irb-ref/${id}`);
        const result = response.data;
        console.log("useIRBDocumentsData result", result);
        setData(result);
        
        // Parse form data once
        if (result?.filledForm?.value) {
          try {
            setParsedFormData(JSON.parse(result.filledForm.value));
          } catch (parseError) {
            console.error("Error parsing form data:", parseError);
            setParsedFormData(null);
          }
        }
      } catch (err) {
        console.error("Error fetching IRB documents:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const subforms = data?.stage?.Stage?.Form?.subforms || [];
  const comments = data?.comments || [];
  const requestDetails = {
    reference_number: data?.request?.IRB_Ref || data?.request?.reference_number || id
  };

  return {
    data,
    loading,
    error,
    parsedFormData,
    subforms,
    comments,
    requestDetails,
    requestId: data?.request?.id || data?.request_id,
    requestProgressId: data?.id,
    irbRefId: data?.irbRefId 
  };
};
